import { CSSProperties, ReactNode } from "react";

export enum ButtonSize {
  large,
  small,
  XSmall,
  XXSmall,
}

export enum ButtonColorType {
  light,
  transparentLight,
  dark,
  transparentDark,
}

export interface IButton {
  children?: ReactNode;
  icon?: ReactNode;
  rightIcon?: ReactNode;
  arrowBefore?: boolean;
  arrowAfter?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  ariaDisabled?: boolean;
  isLoading?: boolean;
  fullWidth?: boolean;
  colorType?: ButtonColorType;
  buttonSize?: ButtonSize;
  style?: CSSProperties;
  className?: string;
  id?: string;
  isEnabledKeydown?: boolean;
  "aria-label"?: string;
}
